
export class InvalidInputError extends Error {}

export class MissingFieldError extends Error {}